(function() {
  const sectionName = 'address-list';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${sectionName}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const linkTag = section.querySelector('link');
        const scriptTag = section.querySelector('script');

        linkTag.remove();
        scriptTag.remove();
      }
    });
  } else {
    const citiesItems = document.querySelectorAll('.adressList__citiesItem');

    function toggleContent(target) {
      const currentCity = target.dataset.city;
      const activeCity = target.closest('.adressList').querySelector('.adressList__citiesItem.adressList__citiesItem--active');
      const activeAddresses = target.closest('.adressList').querySelectorAll('.adressList__contentItem.adressList__contentItem--active');
      const currentCities = target.closest('.adressList').querySelectorAll(`.adressList__contentItem[data-city="${currentCity}"]`);

      if (target.matches('.adressList__citiesItem--active')) {
        return
      }

      activeCity.classList.remove('adressList__citiesItem--active');
      target.classList.add('adressList__citiesItem--active');

      activeAddresses.forEach((address) => {
        address.classList.remove('adressList__contentItem--active');
      });

      currentCities.forEach((city) => {
        city.classList.add('adressList__contentItem--active');
      });
    }

    citiesItems.forEach((city) => {
      city.addEventListener('click', (e) => {
        toggleContent(e.currentTarget);
      });
    });

    Shopify.theme.sections.register(sectionName);
  }
})();
